import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import { usePickupOrderSettings } from '@/api/config/queries/usePickupOrderSettings'
import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

export const useAllowPickupOrderFeature = () => {
  const { data: loggedUser } = useCurrentUser()
  const { data: settings } = usePickupOrderSettings()
  const isAdminOrUk = !!loggedUser?.permissions?.Admin || loggedUser?.warehouse === PkgWarehouse.UK
  const isInAllowedList = settings?.allowed ?? false
  const allowPickupOrderFeature = isInAllowedList || isAdminOrUk

  const serviceDisabled = settings?.serviceDisabled ?? false
  const isAtCapacity = settings?.isAtCapacity ?? false

  return {
    allowPickupOrderFeature,
    isServiceDisabled: serviceDisabled || isAtCapacity,
  }
}
